export const feedSolicitationsSteps = [
  {
    target: '#start-item',
    content: 'Esta componente exibe suas Demandas ou Solicitações em andamento.',
    disableBeacon: true,
  },
  {
    target: '#expand-icon',
    content: 'Você pode visualizar detalhes clicando neste icone.',
  },
  {
    target: '#solicitation-modal',
    content: 'Os detalhes da solicitação ou demanda são exibidos em um Modal.',
    delay: 1000,
  },
  {
    target: '#solicitation-modal-actions',
    content: 'Aqui você pode aplicar alterações na Solicitação ou Demanda.',
  },
  {
    target: '#solicitation-modal-details',
    content: 'Aqui são exibidos todos os detalhes da Solicitação ou Demanda.',
  },
];
